module.exports = __webpack_public_path__ + "static/media/overlapping.0b9fe357.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/ep8/overlapping.png
 ** module id = 234
 ** module chunks = 0
 **/